<div class="st-page">
  <a class="st-back-link" (click)="goBack()"><i class="ri-arrow-left-line"></i> {{ 'backToClass' | translate }}</a>

  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'students' | translate }}</h1>
      <p class="st-subtitle">{{ students.length }} {{ 'studentsInThisClass' | translate }}</p>
    </div>
  </div>

  <div class="st-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i> {{ 'couldntLoadTheStudentListPleaseTryAgain' | translate }}
  </div>

  <div class="st-empty-state" *ngIf="!loading && !loadError && students.length === 0">
    <i class="ri-group-line"></i> {{ 'noStudentsFoundForThisClass' | translate }}
  </div>

  <div class="st-card" *ngIf="loading || (!loadError && students.length)">
    <ng-container *ngIf="loading; else studentList">
      <div class="st-list-row scs-skeleton-row" *ngFor="let s of skeletonPlaceholders">
        <div class="st-avatar scs-skeleton scs-skeleton-circle"></div>
        <div class="st-list-text">
          <div class="scs-skeleton scs-skeleton-line scs-skeleton-line-title"></div>
          <div class="scs-skeleton scs-skeleton-line scs-skeleton-line-sub"></div>
        </div>
        <div class="scs-skeleton scs-skeleton-chip"></div>
      </div>
    </ng-container>
    <ng-template #studentList>
      <div class="st-list-row" *ngFor="let s of students" (click)="openStudent(s)">
        <div class="st-avatar">
          <img *ngIf="s.raw.studentImage" [src]="s.raw.studentImage" alt="" />
          <ng-container *ngIf="!s.raw.studentImage">{{ s.initials }}</ng-container>
        </div>
        <div class="st-list-text">
          <div class="st-list-title">{{ s.name }}</div>
          <div class="st-list-sub">{{ 'rollNo' | translate }}. {{ s.rollNo }}</div>
        </div>
        <i class="ri-arrow-right-s-line scs-row-arrow"></i>
      </div>
    </ng-template>
  </div>
</div>
